<template>
  <div class="xero-wrap xero-wrap-mobile">
      <div class="logo"></div>
      <div class="content">
          <h1>Welcome to Peiso!</h1>
          <h2>To start using Peiso, you are required to register your <br />
account by clicking on the link below.</h2>

            <div class="supported d-flex flex-column gap-16">
                <span class="d-block text-center">
                    Platform supported:
                </span>

                <div class="logo-wrapper d-flex justify-content-center align-items-center gap-16 m-bottom-1rem">
                    <div v-for="(item, i) in integrations" :key="`integration-${i}`" class="logo-container white d-flex align-items-center" :class="item.customClass">
                        <img :src="item.image" height="80px" width="80px" class="object-fit-contain" alt="">
                    </div>
                </div>
            </div>
          <button class="welcome" @click="next">Register my account</button>
          <h3>Once you have registered your account, you will be able to login to the Peiso Venue Portal.</h3>
          <p>If you have trouble logging in, contact Peiso for support at <a href="mailto:support@peiso.com.au">support@peiso.com.au</a></p>
      </div>
  </div>
</template>

<script> 
import kseries from '@/assets/lightspeed-logo.png'
import oseries from '@/assets/lightspeed-logo-o-series.jpg'
import doshii from '@/assets/doshii-logo.png'
import handl from '@/assets/handl-logo.png'
import tevalis from '@/assets/tevalis-logo.svg'
import redcat from '@/assets/redcat-logo.svg'
import square from '@/assets/square-logo.png'
import idealpos from '@/assets/idealpos.png'
import impos from '@/assets/impos.svg'
import tanda from '@/assets/tanda-logo.png'
import deputy from '@/assets/deputy-logo.png'
export default {
  name: 'login',
  data () {
    return {
        isPro: false,
        integrations: []
    }
  },
  methods: {
      next () {

            let request_params = {
                isPro:  false //this.isPro
            }

            sessionStorage.setItem('request_params', JSON.stringify(request_params))

            if (this.$route.query.code)
                this.$router.replace(`/register?code=${this.$route.query.code}`)
            else {
                this.$router.replace(`/register`)
            }

            
      },
      addImageList() {
        this.integrations.push({image: kseries, isEnable: true, customClass: 'p-5-all'})
        this.integrations.push({image: oseries, isEnable: true, customClass: 'p-5-all'})
        this.integrations.push({image: doshii, isEnable: false})
        this.integrations.push({image: handl, isEnable: this.isPro ? true : false, customClass: 'p-5-all'})
        this.integrations.push({image: tevalis, isEnable: true, customClass: 'p-5-all tevalis-bg'})
        this.integrations.push({image: redcat, isEnable: true, customClass: 'p-5-all'})
        this.integrations.push({image: square, isEnable: true, customClass: 'p-5-all'})
        this.integrations.push({image: idealpos, isEnable: true, customClass: 'p-5-all'})
        this.integrations.push({image: impos, isEnable: false, customClass: 'p-5-all'})
        this.integrations.push({image: tanda, isEnable: true, customClass: 'p-5-all tanda-bg'})
        this.integrations.push({image: deputy, isEnable: true, customClass: 'p-5-all deputy-bg'})
        
        this.integrations = this.integrations.filter((n) => n.isEnable)
      }
  },
  mounted() {
    if (this.$route.params && this.$route.params.type == 'pro') {
        this.isPro = true
    }

    sessionStorage.setItem('isPro', this.isPro)
    
    this.addImageList()
    
  }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';
@import 'static/scss/media-queries';
.content {
    width: 100%;
    box-sizing: border-box;
    background-color: var(--background-color-4);
    padding: 120px 100px 134px 120px;
    h1{
        @include pingfang-medium-font(30px, 42px, 600, $white) {
            margin-bottom: 40px;
            text-align: center;
        }
    }
    h2{
        @include pingfang-medium-font(24px, 36px, 600, $white) {
            word-break: break-word;
            margin-bottom: 40px;
            text-align: center;
        }
        span {
          display: block;
          @include mobile-lg {
            display: unset;
          }
        }
    }
    button {
        @include pingfang-medium-font(22px, normal, 600, $white) {
            border: none;
            display: block;
            margin: 0 auto 60px auto;
            cursor: pointer;
            width: 310px;
            height: 50px;
            background: #EA3796;
        }
        
        @include mobile-lg {
          font-size: 18px;
        }
    }
    h3{
        @include pingfang-medium-font(24px, 33px, 600, $white) {
            padding-top: 30px;
            border-top: 1px solid #5F5F5F;
            margin-bottom: 30px;
            word-break: break-word;
        }

        @include mobile-lg {
            font-weight: 400;
        }
    }
    p{
        a{
            color: var(--text-color);
        }
        @include pingfang-medium-font(18px, 25px, 400, $white2) {
            word-break: break-word;
        }
    }

    .supported {
        margin-bottom: 2rem;
        span {
            color: var(--text-color);
            font-weight: 700;
            
        }
        .logo-container {
            border-radius: 5px;
            &.white {
                background: var(--text-color);
            }

            &.handl {
                display: flex;
                align-items: center;
                justify-content: center;
            }

        }

        .logo-wrapper {
            flex-wrap: wrap;
            @include mobile-lg {

                .ls-logo {
                    height: 40px;
                }

                .other-logo {
                    height: 65px;
                }
            }
        }
    }

    
}
</style>



// WEBPACK FOOTER //
// src/components/register/welcome.vue